import focusableElementsString from '@/_utils/focusableElementsString'
/**
 * Show the sticky header when we've scrolled out of the header's view,
 * and show the main header when it enters the viewport.
 */
const showHideMenu = () => {
  const header = document.querySelector( 'header.main' )
  const stickyHeader = document.querySelector( 'header.fixed' )
  const focusableElements = stickyHeader ? stickyHeader.querySelectorAll<HTMLElement>( focusableElementsString ) : []
  focusableElements.forEach( element => element.tabIndex = -1 )

  const observer = new IntersectionObserver( entries => {
    const target = entries[0].target
    if ( ! entries[0].isIntersecting ) {
      if ( stickyHeader ) {
        focusableElements.forEach( element => element.tabIndex = 0 )
        stickyHeader.classList.remove( 'opacity-0' )
        stickyHeader.classList.add( 'opacity-100' )
        stickyHeader.ariaHidden = 'false'
        stickyHeader.classList.remove( 'pointer-events-none' )
        stickyHeader.classList.add( 'pointer-events-auto' )
        target.classList.remove( 'opacity-100' )
        target.classList.add( 'opacity-0' )
        target.ariaHidden = 'true'
      }
    }
    else {
      if ( stickyHeader ) {
        stickyHeader.classList.add( 'opacity-0' )
        stickyHeader.ariaHidden = 'true'
        stickyHeader.classList.remove( 'opacity-100' )
        stickyHeader.classList.remove( 'pointer-events-auto' )
        stickyHeader.classList.add( 'pointer-events-none' )
        target.classList.remove( 'opacity-0' )
        target.classList.add( 'opacity-100' )
        target.ariaHidden = 'false'
      }
    }
  } )

  if ( header ) observer.observe( header )

}

export default showHideMenu
